export enum ArtifactFileType {
  STATEMENT_OF_WORK = 'STATEMENT_OF_WORK',
  CHANGE_REQUEST = 'CHANGE_REQUEST',
  ACCEPTANCE = 'ACCEPTANCE',
  MSA = 'MSA',
  NDA = 'NDA',
  AMENDMENT = 'AMENDMENT',
  PROJECT_WEEKLY_REPORT = 'PROJECT_WEEKLY_REPORT',
  COMPANY_SERVICE_BUDGET = 'COMPANY_SERVICE_BUDGET',
}
